import { provideCommonAuthService } from '@invivodf/front-seller-auth/src/useAuth'
import { useAuthentication } from '@/retail/contexts/user/application/composables/useAuthentication'

// Retail: Auth0 via @auth0/auth0-spa-js (retail repository), common auth port
// backed by it. No ScopesService (retail authorizes per requested retail scope).
export function bootstrapRetailAuth(): void {
  provideCommonAuthService({
    getAccessToken: async () => (await useAuthentication().getAccessToken()).access_token,
    getUserScopes: useAuthentication().getUserScopes,
  })
}
